module.exports={render:function (){with(this) {
  return _h('button', {
    staticClass: "disable-hover  ",
    class: [
      role,
      theme ? role + '-' + theme : '',
      type ? role + '-' + type : '',
      theme ? role + '-' + type + '-' + theme : '',
      aColor,
      isActive ? 'activated' : '',
      aRound,
      aBlock,
      aFull,
      aSize,
      isParentItem ? 'item-button' : ''
    ],
    on: {
      "touchstart": handleTouchStart
    }
  }, [_h('span', {
    staticClass: "button-inner"
  }, [_t("default")]), " ", _m(0)])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "button-effect"
  })
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bdf18508!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/src/button.vue
// module id = 169
// module chunks = 0